import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '../helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'mission/';

class MissionService {
    getOngoingMissions() {
        return axios.get(API_URL + 'getongoingmissions/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    getPendingMissions() {
        return axios.get(API_URL + 'getpendingmissions/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    getFinishedMissions(params = {}) {
        const queryParams = {};

        if (params.page != null) queryParams.page = params.page;
        if (params.perPage != null) queryParams.perPage = params.perPage;
        if (params.startDate != null) queryParams.startDate = params.startDate;
        if (params.endDate != null) queryParams.endDate = params.endDate;

        return axios.get(API_URL + 'getfinishedmissions/' + UserHelper.getClientId(), {
            headers: authHeader(),
            params: queryParams
        });
    }

    getMission(id) {
        return axios.get(API_URL + 'getmission/' + id, { headers: authHeader() });
    }

    createMission(data) {
        return axios.put(
            API_URL + 'createclientmission/' + UserHelper.getClientId(),
            data,
            { headers: authHeader() }
        );
    }

    updateMission(data, mId) {
        return axios.put(API_URL + 'updatemission/' + mId, data, { headers: authHeader() });
    }

    transporteurUpdate(mId, data) {
        return axios.put(API_URL + 'transporteurupdate/' + mId, data, { headers: authHeader() });
    }

    launchTest(mId) {
        return axios.put(API_URL + 'launchtest/' + mId, {}, { headers: authHeader() });
    }

    addMissionBalise(data, mId) {
        return axios.put(API_URL + 'addmissionbalise/' + mId, data, { headers: authHeader() });
    }

    removeMissionBalise(data, mId) {
        return axios.put(API_URL + 'removemissionbalise/' + mId, data, { headers: authHeader() });
    }

    addMissionMember(data, mId) {
        return axios.put(API_URL + 'addmissionmember/' + mId, data, { headers: authHeader() });
    }

    removeMissionMember(data, mId) {
        return axios.put(API_URL + 'removemissionmember/' + mId, data, { headers: authHeader() });
    }

    endDraft(mId) {
        return axios.put(API_URL + 'enddraft/' + mId, {}, { headers: authHeader() });
    }

    startMission(mId, startComment) {
        return axios.put(API_URL + 'startmission/' + mId, { startComment }, { headers: authHeader() });
    }

    endMission(mId, endComment) {
        return axios.put(API_URL + 'endmission/' + mId, { endComment }, { headers: authHeader() });
    }

    cancelMission(mId) {
        return axios.put(API_URL + 'cancel/' + mId, {}, { headers: authHeader() });
    }

    deleteMission(id) {
        return axios.delete(API_URL + 'deletemission/' + id, { headers: authHeader() });
    }

    create(data) {
        return axios.put(API_URL + 'create/' + UserHelper.getClientId(), data, { headers: authHeader() });
    }

    addMissionPlate(missionId, immat) {
        return axios.post(API_URL + `missionplate/${missionId}`, { immat }, { headers: authHeader() });
    }

    removeMissionPlate(missionId, plateId) {
        return axios.delete(API_URL + `missionplate/${missionId}/${plateId}`, { headers: authHeader() });
    }

    addMissionBalisesByGroups(missionId, groupIds) {
        return axios.put(
            API_URL + `addgroupsbalises/${missionId}`,
            { groupIds },
            { headers: authHeader() }
        );
    }

    getMissionPrecheckValues(missionId) {
        return axios.get(API_URL + `${missionId}/precheckvalues`, { headers: authHeader() });
    }

    updateMissionPrecheckValue(missionId, valueId, value) {
        return axios.put(
            API_URL + `${missionId}/precheckvalue/${valueId}`,
            { value },
            { headers: authHeader() }
        );
    }

    getMissionComments(missionId) {
        return axios.get(API_URL + `${missionId}/comments`, { headers: authHeader() });
    }
    createMissionComment(missionId, content) {
        return axios.post(API_URL + `${missionId}/comments`, { text: content }, { headers: authHeader() });
    }
}

export default new MissionService();